import { Popover } from '@material-ui/core';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import HomeIcon from '@material-ui/icons/Home';
import momentz from 'moment-timezone';
import { is_weekend } from '../../Modals/UOAModal/getDate';
import DesktopNav from '../DesktopNav';
import { styles } from '../index.styles';
import premiumMobile from '../../mobilepremium.png';
import FavIcon from '../../icon.png';
import { mobileSubnavLinks } from '../../../constants';

const SubNav = () => {
  const history = useHistory();

  /** @type {import('../../../typings').IStateReducerState}*/
  const { isMobile, width, accessLevel } = useSelector(
    (state) => state.appReducer
  );

  const [menuState, setMenuState] = useState(
    /** @type {import('../../typings').IHeaderState} */ ({
      anchorEl: null,
      openSub1: false,
      openSub2: false,
      ticker: '',
      symbol: '',
      date: '',
      hover: false,
      anchorElHover: null,
      anchorElStockMenu: null,
      anchorElOpenInterest: null,
      anchorMobile: null,
      anchorWatchlist: null,
    })
  );

  const mobileOpen = Boolean(menuState.anchorMobile);
  const id = mobileOpen ? 'simple-popover' : undefined;

  const setDate = () => {
    const date = momentz
      .tz(new Date(), 'America/New_York')
      .format('YYYY-MM-DD');
    const newDate = is_weekend(date);
    localStorage.setItem('Date', newDate);
    setMenuState({ ...menuState, date: newDate });
  };

  const handleClick = (url) => {
    setDate();
    history.push(url);
    setMenuState({ ...menuState, anchorEl: null });
  };

  return (
    <div
      style={{ ...(isMobile ? styles.headerMobile : styles.header) }}
      className="sticky"
    >
      {width > 850 ? (
        <DesktopNav menuState={menuState} setMenuState={setMenuState} />
      ) : (
        <div aria-describedby={id} style={styles.buttonWrapperTopMobile}>
          <div
            style={
              window.location.href.includes('home')
                ? { ...styles.headerBtnEnable, paddingTop: '2px' }
                : { ...styles.headerBtnDisable, paddingTop: '2px' }
            }
            onClick={(event) => {
              if (accessLevel === 'halfaccess') {
                this.handlePopoverMobileOpen(event);
              } else {
                setDate();
                history.push('/home');
                setMenuState({ ...menuState, anchorEl: null });
              }
            }}
          >
            <HomeIcon />
          </div>
          <Popover
            id={id}
            open={mobileOpen}
            anchorEl={menuState.anchorMobile}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            onClose={() => setMenuState({ ...menuState, anchorMobile: null })}
          >
            <div
              onClick={() => {
                window.location.replace('https://bit.ly/3IQTN4B');
              }}
              style={{ width: '250px' }}
            >
              <img height="100%" width="100%" src={premiumMobile} alt="" />
            </div>
          </Popover>

          {mobileSubnavLinks.map(({ label, url, accessLevel, style }) => (
            <div
              key={label}
              style={{
                ...styles.headerBtn,
                ...(window.location.href.includes(url)
                  ? styles.headerBtnEnable
                  : styles.headerBtnDisable),
                ...style,
              }}
              onClick={(event) => {
                if (accessLevel === 'fullaccess') {
                  history.push(url);
                }
                if (accessLevel === 'halfaccess') {
                  setMenuState({
                    ...menuState,
                    anchorMobile: event.currentTarget,
                  });
                } else {
                  handleClick(url);
                }
              }}
            >
              {url.includes('watchlist') ? (
                <div
                  style={{
                    width: '45px',
                    height: '20px',
                    marginLeft: '8px',
                  }}
                >
                  <img height="100%" width="100%" src={FavIcon} alt="" />
                </div>
              ) : (
                label
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SubNav;



// WEBPACK FOOTER //
// ./src/components/Header/SubNav/index.jsx